import { render, staticRenderFns } from "./cModalCamposRemi.vue?vue&type=template&id=16be9582&scoped=true"
import script from "./cModalCamposRemi.vue?vue&type=script&lang=js"
export * from "./cModalCamposRemi.vue?vue&type=script&lang=js"
import style0 from "./cModalCamposRemi.vue?vue&type=style&index=0&id=16be9582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16be9582",
  null
  
)

export default component.exports